import advokacie from "./Logos/advokacie_mediace.webp"
import appliner from "./Logos/appliner.webp"
import berrys from "./Logos/berrys.webp"
import dogs4u from "./Logos/dogs4u.webp"
import doprava from "./Logos/dopravabrno.webp"
import enterprises from "./Logos/enterprises.webp"
import gopay from "./Logos/gopay.webp"
import hlidani from "./Logos/hlidani_ins.webp"
import kasal from "./Logos/kasal_promotion.webp"
import klimes from "./Logos/klimes.webp"
import story from "./Logos/story_mages.webp"
import svitil from "./Logos/svitil_ip.webp"
import trading from "./Logos/trading_mentors.webp"
import unikovky from "./Logos/unikovky.webp"
import vyhledavani from "./Logos/vyhledavani_exe.webp"
import mechu from "./Logos/mechu.webp"

const partnerLogos = [
    { src: appliner, link: 'https://appliner.cz/', name: 'Appliner', field: "Vývoj studijních aplikací" },
    { src: berrys, link: 'https://www.berrys.cz/', name: 'Berrys', field: "Prodej výživných nápojů" },
    { src: dogs4u, link: 'https://dogs4u.cz/', name: 'DOGS4U', field: "Prodej chovatelských potřeb" },
    { src: advokacie, link: 'https://www.vkadmed.cz/', name: 'VK advokacie & mediace', field: "Advokacie a mediace" },
    { src: doprava, link: 'https://dopravabrno.cz/', name: 'dopravabrno.cz, bagr-brno.cz', field: "Stavebnictví" },
    //{ src: enterprises, link: 'https://metastreamenterprises.cz/', name: 'Metastream Enterprises', field: "Vývoj softwaru" },
    { src: mechu, link: 'https://www.mechu.cz/', name: 'mechu.cz', field: "Prodej mechanických součástek" },
    { src: gopay, link: 'https://www.gopay.com/', name: 'GoPay', field: "Poskytovatel platebních služeb" },
    { src: kasal, link: 'https://kasalpromotion.cz/', name: 'Kasal promotion', field: "Marketing a společenské události" },
    { src: klimes, link: false, name: 'Ing. Petr Klimeš', field: "Odhady nemovitých věcí" },
    { src: story, link: 'https://storymages.com/', name: 'Story mages', field: "Natáčení videoklipů" },
    { src: unikovky, link: 'https://unikovky-litomysl.cz/', name: 'Únikovky Litomyšl', field: "Pořádání volnočasových aktivit" },
    { src: svitil, link: 'https://svitilip.cz/', name: 'Svítil IP', field: "Patentový zástupce" },
    { src: trading, link: 'https://tradingmentors.cz/', name: 'Trading Mentors', field: "Trading" },
    { src: hlidani, link: 'https://hlidaniinsolvenci.cz/', name: 'Hlídání insolvencí', field: "Kontrola solventnosti" },
    { src: vyhledavani, link: 'https://vyhledavaniexekuci.cz/', name: 'Vyhledávání exekucí', field: "Kontrola solventnosti" }
];

export default partnerLogos;